const fullcontJump = require('../../../../../components/fullcont/fullcont-jump')

export function jumperToPurchase(detail, htmlFc){

      const line         = htmlFc.fullcontHTML.querySelector(`.line-${detail.lineId}`)
      const purchaseCode = line.querySelector('.purchase_code input')

      fullcontJump.start({
            actJump:  'goToPurchase',
            dtId:     'purchase-dt',
            toSearch: purchaseCode.value,
      })
}
